module.exports = __webpack_public_path__ + "static/media/emptyCheck.38c5d68e.png";